import { render, staticRenderFns } from "./LogoCard.vue?vue&type=template&id=dc45efa0&scoped=true"
import script from "./LogoCard.vue?vue&type=script&lang=js"
export * from "./LogoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc45efa0",
  null
  
)

export default component.exports